import { COLUMN_SIZE } from '../DataGridDevEx/DataGrid.constants';

export const getProductLookupColumns = (Warehouse?: string) => [
    {
        dataField: 'Details.MatchType',
        caption: '',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: true
    },
    {
        dataField: 'Details.ProductCode',
        caption: 'Product',
        allowResizing: true,
        minWidth: COLUMN_SIZE.ProductCodeField,
        width: COLUMN_SIZE.ProductCodeField,
        fixed: true
    },
    {
        dataField: 'Details.ProductGroup',
        caption: 'Group',
        allowResizing: true,
        minWidth: COLUMN_SIZE.ProductGrupField,
        width: COLUMN_SIZE.ProductGrupField,
        fixed: false
    },
    {
        dataField: 'Details.AvailableQuantity',
        caption: `Available (${Warehouse})`,
        allowResizing: true,
        minWidth: COLUMN_SIZE.QuantityField,
        width: COLUMN_SIZE.QuantityField,
        fixed: false
    },
    {
        dataField: 'Description',
        caption: 'Description',
        allowResizing: true,
        minWidth: COLUMN_SIZE.Description,
        width: COLUMN_SIZE.Description,
        fixed: false
    },
    {
        dataField: 'Reference',
        caption: 'Reference',
        allowResizing: true,
        minWidth: COLUMN_SIZE.ReferenceField,
        width: COLUMN_SIZE.ReferenceField,
        fixed: false
    },
];
export const getProductSearchColumns = (Warehouse?: string) => [
    {
        dataField: 'Details.ProductCode',
        caption: 'Product',
        allowResizing: true,
        minWidth: COLUMN_SIZE.ProductCodeField,
        width: COLUMN_SIZE.ProductCodeField,
        fixed: true
    },
    {
        dataField: 'Details.ProductGroup',
        caption: 'Group',
        allowResizing: true,
        minWidth: COLUMN_SIZE.ProductGrupField,
        width: COLUMN_SIZE.ProductGrupField,
        fixed: false
    },
    {
        dataField: 'Details.AvailableQuantity',
        caption: `Available (${Warehouse})`,
        allowResizing: true,
        minWidth: COLUMN_SIZE.QuantityField,
        width: COLUMN_SIZE.QuantityField,
        fixed: false
    },
    {
        dataField: 'Description',
        caption: 'Description',
        allowResizing: true,
        minWidth: COLUMN_SIZE.Description,
        width: COLUMN_SIZE.Description,
        fixed: false
    }
];
export const SEARCH_SCREEN_DIALOG_STYLE = {
    width: 'calc(71%)',
    maxWidth: 'calc(71%)',
    height: 'calc(100% - 300px)',
    maxHeight: 'calc(100% - 300px)',
};
